import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  computed,
  input,
} from '@angular/core';
import { FieldTree } from '@angular/forms/signals';
import {
  VspRegulationLookupComponent,
  VspRegulationLookupValue,
  sameVspSelection,
} from './vsp-regulation-lookup.component';
import { LookupSelections, lookupList } from '../regulation-lookup-list';

@Component({
  selector: 'app-vsp-regulation-lookup-list',
  imports: [VspRegulationLookupComponent],
  templateUrl: './vsp-regulation-lookup-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VspRegulationLookupListComponent implements OnInit {
  readonly field =
    input.required<FieldTree<LookupSelections<VspRegulationLookupValue>>>();

  protected readonly state = computed(() => this.field()());
  private readonly list = lookupList(() => this.field(), sameVspSelection);
  readonly entries = this.list.entries;

  ngOnInit(): void {
    this.list.seed();
  }

  addItem(): void {
    this.list.add();
  }
}
